import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
export const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Brisbane', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
export function money(value: unknown) {
  return value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 2 }).format(Number(value));
}
export function units(value: unknown) {
  return value == null || value === '' || !Number.isFinite(Number(value)) ? '—' : new Intl.NumberFormat('en-AU', { maximumFractionDigits: 8 }).format(Number(value));
}
export function percent(value: unknown) { return value == null || !Number.isFinite(Number(value)) ? '—' : `${(Number(value) * 100).toFixed(2)}%`; }
export function percentagePoints(value: unknown) { return value == null || !Number.isFinite(Number(value)) ? '—' : `${Number(value).toFixed(2)}%`; }
export function date(value: unknown) {
  if (!value) return '—';
  const d = new Date(String(value));
  return Number.isNaN(d.valueOf()) ? String(value) : new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Australia/Brisbane' }).format(d);
}
export function datetime(value: unknown) {
  if (!value) return '—';
  const d = new Date(String(value));
  return Number.isNaN(d.valueOf()) ? String(value) : new Intl.DateTimeFormat('en-AU', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Australia/Brisbane' }).format(d);
}
export function saveFile(content: BlobPart, name: string, type = 'text/csv;charset=utf-8') {
  const href = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement('a'); a.href = href; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1_000);
}
export function csv(rows: unknown[][]) {
  return rows.map(row => row.map(v => {
    let value = v == null ? '' : String(v);
    if (/^[=+@\t\r]/.test(value) || /^-\D/.test(value)) value = `'${value}`;
    return `"${value.replaceAll('"', '""')}"`;
  }).join(',')).join('\r\n');
}

export function scheduleDescription(cron?: string) {
  if (!cron) return 'On demand';
  const [minute, hour, day, month, weekday] = cron.split(' ');
  if (/^\d+$/.test(minute) && /^\d+$/.test(hour) && month === '*') {
    const time = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return `${weekday === '1-5' ? 'Weekdays' : /^\d$/.test(weekday) ? days[Number(weekday)] : day !== '*' ? `Day ${day} monthly` : 'Daily'} at ${time}`;
  }
  return `Custom: ${cron}`;
}
